import React from 'react';
import Box from '@mui/material/Box';

import { StoreCard } from './OrganizationCard';

// Org chart connectors drawn with borders on pseudo-elements: each child
// draws its half of the horizontal bar above it plus a vertical tick, and the
// children row draws the vertical line coming down from the parent.
const GAP = 3; // theme.spacing units between a card and the bar

const lineColor = { borderColor: 'divider' };

const childrenRowSx = {
  display: 'flex',
  justifyContent: 'center',
  position: 'relative',
  listStyle: 'none',
  m: 0,
  p: 0,
  pt: GAP,
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: '50%',
    height: (theme) => theme.spacing(GAP),
    borderLeft: '1px solid',
    ...lineColor,
  },
};

const childSx = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  position: 'relative',
  px: 1,
  pt: GAP,
  '&::before, &::after': {
    content: '""',
    position: 'absolute',
    top: 0,
    width: '50%',
    height: (theme) => theme.spacing(GAP),
    borderTop: '1px solid',
    ...lineColor,
  },
  '&::before': { right: '50%' },
  '&::after': { left: '50%', borderLeft: '1px solid', ...lineColor },
  // The bar stops at the outermost children.
  '&:first-of-type::before, &:last-of-type::after': { borderTop: 'none' },
};

export function ChildrenRow({ t, nodes }) {
  if (!nodes.length) return null;
  return (
    <Box component="ul" sx={childrenRowSx}>
      {nodes.map((node) => (
        <Box component="li" key={node.business.uuid} sx={childSx}>
          <StoreCard t={t} business={node.business} />
          <ChildrenRow t={t} nodes={node.children} />
        </Box>
      ))}
    </Box>
  );
}
